<template>
<div>
    <router-link  :to="props.ship.link" class="cruise-info__ship" target="_blank"><vShip class="icon vicon-black" />{{props.ship.name}} [{{props.ship.company}}] - {{props.ship.star}}</router-link>

    <div v-if="ship.services.length" @click.stop.prevent="serv_click"  class="cruise-info__services">Услуги на борту</div>

    <Modal v-model="isModalShown"
        title=""
        wrapper-class="animate__animated"
        modal-class="fill-modal"
        in-class="animate__zoomIn hideScroll"
        out-class="animate__zoomOut hideScroll">

        <div class="fill-modal__header fill-modal-header">
            <ModalTitle class="fill-modal-header__title" @close="isModalShown = false">
                {{props.ship.name}} [{{props.ship.company}}] - {{props.ship.star}}
            </ModalTitle>
        </div>

        <div class="fill-modal__content shipServ">
            <div class="shipServ__item" v-for="({name,icon}) in props.ship.services" :key="name">
                <img class="shipServ__item__img" :src="icon" />
                <span class="shipServ__item__desc">{{name}}</span>
            </div>
            
        </div>
    
    </Modal>
</div>
</template>

<script setup>
import '@/comp/CruiseInList/CruiseInList.scss' // чтобы стили не попадали в сборку дважды     

import {ref,unref} from 'vue'

import vShip from '@/assets/vicons/shipfigma.vue'

import ModalTitle from '@/comp/ModalTitle/ModalTitle.vue'
import Modal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import 'animate.css'

const isModalShown = ref(false)

const props = defineProps({
    ship: Object,
})

const serv_click = () => {
    isModalShown.value = true
}
</script>

<style lang="scss">
.shipServ {
//   grid-template-rows: repeat(5, 1fr);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px 24px;
    grid-auto-flow: column;
    grid-auto-flow: row;

    &__item {
        display: flex;
        align-items: center;
        column-gap: 8px;
        height: fit-content;    
        &__img {
            width: 24px; 
            height: 24px;
        }
        &__desc {
            font-size: 16px;
            line-height: 1.4;
        }
    }
}
</style>
